namespace Matrix.Data {
    export interface SecurityRow {
        SecurityId?: number;
        SecurityCode?: string;
        Name?: string;
        DisplayName?: string;
        DealParentCode?: string;
        SecurityTypeCode?: string;
        LocalCurrencyCode?: string;
        ExposureMultiplier?: number;
        AssociatedAccountCode?: string;
        Sedol?: string;
        RIC?: string;
        Isin?: string;
        Cusip?: string;
        Figi?: string;
        Ticker?: string;
        InternalSecurityCode?: string;
        Issuer?: string;
        IssuerCode?: string;
        BorrowerCode?: string;
        CouponRate?: number;
        MaturityDate?: string;
        SpLtRating?: string;
        SpStRating?: string;
        MoodysLtRating?: string;
        MoodysStRating?: string;
        FitchLtRating?: string;
        FitchStRating?: string;
        InternalLtRating?: string;
        InternalStRating?: string;
        CountryOfIssueCode?: string;
        CountryOfRiskCode?: string;
        CurrencyOfRiskCode?: string;
        TradeDate?: string;
        EffectiveDate?: string;
        BrokerCode?: string;
        Strategy?: string;
        OptionStyle?: string;
        ExerciseStyle?: string;
        PutOrCall?: string;
        StrikePrice?: number;
        StrikeCurrency?: string;
        Premium?: number;
        PremiumCcy?: string;
        PayOrRec?: string;
        FixedOrFloat?: string;
        FloatIndex?: string;
        InflationIndexLag?: string;
        InterestTerm?: string;
        Spread?: number;
        AllIn?: number;
        InterestCcy?: string;
        PaymentFrequency?: string;
        PaymentBusDayConvention?: string;
        PaymentCalendar?: string;
        FirstPaymentDate?: string;
        DayCountBasis?: string;
        ResetFrequency?: string;
        ResetBusDayConvention?: string;
        ResetCalendar?: string;
        ClearerReference?: string;
        RedCode?: string;
        CreditEvents?: string;
        Guarantor?: string;
        CreatedBy?: string;
        GicsSector?: number;
        GicsIndustryGroup?: number;
        GicsIndustry?: number;
        GicsSubIndustry?: number;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        RowId?: number;
        Version?: number;
    }

    export namespace SecurityRow {
        export const idProperty = 'SecurityId';
        export const nameProperty = 'DisplayName';
        export const localTextPrefix = 'Data.Security';
        export const lookupKey = 'Data.Security';

        export function getLookup(): Q.Lookup<SecurityRow> {
            return Q.getLookup<SecurityRow>('Data.Security');
        }
        export const deletePermission = 'DataAdmin:Security';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Read:Security';
        export const updatePermission = 'DataAdmin:Security';

        export declare const enum Fields {
            SecurityId = "SecurityId",
            SecurityCode = "SecurityCode",
            Name = "Name",
            DisplayName = "DisplayName",
            DealParentCode = "DealParentCode",
            SecurityTypeCode = "SecurityTypeCode",
            LocalCurrencyCode = "LocalCurrencyCode",
            ExposureMultiplier = "ExposureMultiplier",
            AssociatedAccountCode = "AssociatedAccountCode",
            Sedol = "Sedol",
            RIC = "RIC",
            Isin = "Isin",
            Cusip = "Cusip",
            Figi = "Figi",
            Ticker = "Ticker",
            InternalSecurityCode = "InternalSecurityCode",
            Issuer = "Issuer",
            IssuerCode = "IssuerCode",
            BorrowerCode = "BorrowerCode",
            CouponRate = "CouponRate",
            MaturityDate = "MaturityDate",
            SpLtRating = "SpLtRating",
            SpStRating = "SpStRating",
            MoodysLtRating = "MoodysLtRating",
            MoodysStRating = "MoodysStRating",
            FitchLtRating = "FitchLtRating",
            FitchStRating = "FitchStRating",
            InternalLtRating = "InternalLtRating",
            InternalStRating = "InternalStRating",
            CountryOfIssueCode = "CountryOfIssueCode",
            CountryOfRiskCode = "CountryOfRiskCode",
            CurrencyOfRiskCode = "CurrencyOfRiskCode",
            TradeDate = "TradeDate",
            EffectiveDate = "EffectiveDate",
            BrokerCode = "BrokerCode",
            Strategy = "Strategy",
            OptionStyle = "OptionStyle",
            ExerciseStyle = "ExerciseStyle",
            PutOrCall = "PutOrCall",
            StrikePrice = "StrikePrice",
            StrikeCurrency = "StrikeCurrency",
            Premium = "Premium",
            PremiumCcy = "PremiumCcy",
            PayOrRec = "PayOrRec",
            FixedOrFloat = "FixedOrFloat",
            FloatIndex = "FloatIndex",
            InflationIndexLag = "InflationIndexLag",
            InterestTerm = "InterestTerm",
            Spread = "Spread",
            AllIn = "AllIn",
            InterestCcy = "InterestCcy",
            PaymentFrequency = "PaymentFrequency",
            PaymentBusDayConvention = "PaymentBusDayConvention",
            PaymentCalendar = "PaymentCalendar",
            FirstPaymentDate = "FirstPaymentDate",
            DayCountBasis = "DayCountBasis",
            ResetFrequency = "ResetFrequency",
            ResetBusDayConvention = "ResetBusDayConvention",
            ResetCalendar = "ResetCalendar",
            ClearerReference = "ClearerReference",
            RedCode = "RedCode",
            CreditEvents = "CreditEvents",
            Guarantor = "Guarantor",
            CreatedBy = "CreatedBy",
            GicsSector = "GicsSector",
            GicsIndustryGroup = "GicsIndustryGroup",
            GicsIndustry = "GicsIndustry",
            GicsSubIndustry = "GicsSubIndustry",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            RowId = "RowId",
            Version = "Version"
        }
    }
}
